export enum EmployeeReportType {
  HR = "hr",
  FINANCE = "finance",
  CAPACITYMANAGER = "capacityManager",
  ZONEBOOKING = "zoneBooking",
  SUPERVISOR = "supervisor",
  DEVICE = "deviceManager",
  NOBOOKING = "noBooking"
}
